import { SET_LINE, ILine } from './types'

//As actions servem para facilitar a chamada aos reducers
export function setLine (line: ILine) {
  return {
    type: SET_LINE,
    payload: line
  }
}